import request from '@/utils/request'

export function uploadLinkPic(data) {
    return request({
        url: '/api/admin/upload/link_pic',
        method: 'post',
        data
    })
}